import { I18n } from "@assets/strings";
import React from "react";
import { useServices } from "@core/servicesContext";
import { Group } from "@domain/group/group";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Stack } from "@ui/components/layout";
import { UnauthorizedGroup } from "./unauthorizedGroup";

interface GroupAccessProps extends React.HTMLAttributes<HTMLDivElement> {
	group: Group;
}

export const GroupAccess: React.FC<GroupAccessProps> = ({ group }) => {
	const { groupService } = useServices();
	return !group.userRole || group.status === "PENDING_HOST_ACCEPTANCE" ? (
		<UnauthorizedGroup group={group} />
	) : group.status === "PENDING_GUEST_ACCEPTANCE" ? (
		<Stack align="center" gap={20}>
			<PrimaryMedium>{I18n.t(`group.${group.type}.invited.title`, { name: group.name })}</PrimaryMedium>
			<PrimaryButton onClick={() => groupService.joinGroup(group.id, group.userRole ?? "MEMBER")}>
				{I18n.t("group.join.button")}
			</PrimaryButton>
		</Stack>
	) : null;
};
